import React from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";

import CustomText from "../../../common/general/CustomText/CustomText";

interface TabNavigationProps {
  activeEntityType: "degree" | "course" | "student";
  hasDegrees: boolean;
  onEntitySelect: (entityType: "degree" | "course" | "student", entityId: string, entityGroupName: string) => void;
}

const TabNavigation: React.FC<TabNavigationProps> = ({ activeEntityType, hasDegrees, onEntitySelect }) => {
  return (
    <View style={styles.tabContainer}>
      <View style={styles.tabRow}>
        {hasDegrees && (
          <TouchableOpacity
            style={[styles.tab, activeEntityType === "degree" && styles.activeTab]}
            onPress={() => onEntitySelect("degree", "", "Degree Programs")}>
            <CustomText text="Degree Programs" weight={activeEntityType === "degree" ? "bold" : "normal"} />
          </TouchableOpacity>
        )}
        <TouchableOpacity
          style={[styles.tab, activeEntityType === "course" && styles.activeTab]}
          onPress={() => onEntitySelect("course", "", "Courses")}>
          <CustomText text="Courses" weight={activeEntityType === "course" ? "bold" : "normal"} />
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.tab, activeEntityType === "student" && styles.activeTab]}
          onPress={() => onEntitySelect("student", "", "Students")}>
          <CustomText text="Students" weight={activeEntityType === "student" ? "bold" : "normal"} />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  tabContainer: {
    marginVertical: 16,
  },
  tabRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#e5e5e5",
  },
  tab: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 16,
    alignItems: "center",
    borderBottomWidth: 2,
    borderBottomColor: "transparent",
    cursor: "pointer",
  },
  activeTab: {
    borderBottomColor: "#0084FF",
  },
});

export default TabNavigation;
